// extracted by mini-css-extract-plugin
module.exports = {"nodata":"NoData_nodata__1Jo-0","nobackground":"NoData_nobackground__cAErp","text":"NoData_text__236xu"};